import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function Register() {
  const [form, setForm] = useState({ full_name:'', email:'', password:'', department:'', joining_date:'' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const set = k => e => setForm(f => ({...f, [k]: e.target.value}));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/register', form);
      toast.success('Registration submitted! Awaiting admin approval.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Registration failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo"><h1>Ta-Da AI HR</h1><p>Employee Registration</p></div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Full Name</label>
            <input className="form-control" required value={form.full_name} onChange={set('full_name')} placeholder="Your full name"/>
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-control" type="email" required value={form.email} onChange={set('email')} placeholder="your@email.com"/>
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-control" type="password" required value={form.password} onChange={set('password')} placeholder="Min 8 characters"/>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Department</label>
              <input className="form-control" value={form.department} onChange={set('department')} placeholder="e.g. Sales"/>
            </div>
            <div className="form-group">
              <label className="form-label">Joining Date</label>
              <input className="form-control" type="date" value={form.joining_date} onChange={set('joining_date')}/>
            </div>
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}
            style={{width:'100%',justifyContent:'center',marginTop:8}}>
            {loading ? 'Submitting...' : 'Submit Registration'}
          </button>
        </form>
        <p className="text-center mt-16 text-sm text-muted">
          Already registered? <Link to="/login" style={{color:'var(--primary)'}}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
